import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { TextField, Typography, FormHelperText } from '@mui/material';
import englishLocale from 'date-fns/locale/en-US';
import PropTypes from 'prop-types';
import { useState } from 'react';

import CommonPropTypes from 'shared/prop-types';

function StandardDatePicker({
	disabled,
	error,
	errorText,
	helperText,
	inputFormat,
	inputProps,
	label,
	subLabel,
	onChange,
	sx,
	labelSx,
	value,
	views
}) {
	const [wasChecked, setWasChecked] = useState(false);

	return (
		<>
			{label && (
				<Typography
					variant="subtitle1"
					sx={{ marginBottom: 1, ...labelSx }}
				>
					{label}
				</Typography>
			)}
			<LocalizationProvider
				dateAdapter={AdapterDateFns}
				adapterLocale={englishLocale}
			>
				<DesktopDatePicker
					disabled={disabled}
					inputFormat={inputFormat}
					value={value}
					views={views}
					onChange={onChange}
					sx={{
						marginTop: 4,
						width: '100%',
						...sx
					}}
					inputProps={inputProps}
					renderInput={(params) => (
						<TextField
							sx={{ width: '100%' }}
							{...params}
							onBlur={() => {
								if (wasChecked === false) setWasChecked(true);
							}}
							error={wasChecked && error}
							helperText={
								wasChecked && error ? errorText : helperText
							}
						/>
					)}
				/>
			</LocalizationProvider>
			{subLabel && (
				<FormHelperText
					variant="standard"
					sx={{
						marginLeft: 2
					}}
				>
					{subLabel}
				</FormHelperText>
			)}
		</>
	);
}

StandardDatePicker.propTypes = {
	disabled: PropTypes.bool,
	error: PropTypes.bool,
	errorText: PropTypes.string,
	helperText: PropTypes.string,
	inputFormat: PropTypes.string,
	label: PropTypes.string,
	labelSx: CommonPropTypes.sx,
	onChange: PropTypes.func,
	sx: CommonPropTypes.sx,
	value: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.instanceOf(Date),
		PropTypes.number
	]),
	views: PropTypes.arrayOf(PropTypes.oneOf(['day', 'month', 'year']))
};

StandardDatePicker.defaultProps = {
	disabled: false,
	error: false,
	errorText: 'something went wrong',
	helperText: '',
	inputFormat: 'MM/dd/yyyy',
	label: 'This is a label',
	labelSx: {},
	onChange: () => {},
	sx: {},
	value: '1985-02-15T07:00:00.000Z',
	views: ['year', 'month', 'day'] // byDefault will show Year Month and Day
};

export default StandardDatePicker;
